import {
  ChangeDetectorRef,
  Component,
  forwardRef,
  Inject,
  Input,
  OnDestroy,
  OnInit
} from '@angular/core';
import { PurchaseResponse }                                        from '@mx51/spi-client-js';
import { NgbActiveModal }                                          from '@ng-bootstrap/ng-bootstrap';

import { API }                          from '../api/api.constant';
import { ApiService }                   from '../api/api.service';
import { AssemblyPaymentsService }      from '../../app/assembly-payments/assembly-payments.service';
import { AssemblyPaymentTerminalModel } from '../../app/assembly-payments/models/assembly-payment.terminal';
import { InvoiceModel }                 from '../invoices/models/invoice';

@Component({
  selector   : 'wor-assembly-payments-transaction',
  template: require('./assembly-payments.transaction.component.html')
})
export class AssemblyPaymentsTransactionComponent implements OnDestroy, OnInit {
  @Input() amount  : number;
  @Input() invoice : InvoiceModel;
  @Input() isRefund: boolean;
  @Input() payment : any;
  @Input() terminal: AssemblyPaymentTerminalModel;

  canCancel          = false;
  canceled           = false;
  complete           = false;
  current_receipt    = null;
  customer_receipt   = null;
  data               = null;
  failed             = false;
  failedReason       = '';
  message            = '';
  signatureAcquired  = false;
  signatureDeclined  = false;
  signatureRequired  = false;
  success            = false;
  transactionUnknown = false;

  receipt : any = {
    customer_receipt         : '',
    merchant_receipt         : '',
    merchant_receipt_with_sig: '',
    payment_status           : ''
  };

  private handleTxFlowStateChanged = ( e ) => this._onTxFlowStateChanged(e);

  constructor (
    public  activeModal             : NgbActiveModal,
    private apiService              : ApiService,
    @Inject(forwardRef(() => AssemblyPaymentsService)) private assemblyPaymentsService : AssemblyPaymentsService,
    private changeDetectorRef       : ChangeDetectorRef
  ) {}

  ngOnInit () : void {


    document.addEventListener('TxFlowStateChanged', this.handleTxFlowStateChanged);


    setTimeout(() => this.run(), 0);


  }

  ngOnDestroy () : void {


    document.removeEventListener('TxFlowStateChanged', this.handleTxFlowStateChanged);


  }

  acceptSignature () : void {


    this.assemblyPaymentsService.spiApi.AcceptSignature(true);

    this.signatureAcquired     = true;
    this.signatureRequired     = false;
    this.receipt.approval_type = 'signature';


  }

  cancel () : void {
    if (!this.success) {
      this.message  = 'Cancelling transaction...';
      this.canceled = true;

      if (this.canCancel) {


        this.changeDetectorRef.detectChanges();


        this.assemblyPaymentsService.spiApi.CancelTransaction();


      }

      this.assemblyPaymentsService.spiApi.AckFlowEndedAndBackToIdle();
    }
  }

  cancelNoTransaction () : void {
    if (!this.success) {

      this.canceled = true;

      this.assemblyPaymentsService.spiApi.AckFlowEndedAndBackToIdle();

      this.activeModal.dismiss();

    }
  }

  close () : void {
    if (this.failed) {

      this.receipt.complete = false;

      this.assemblyPaymentsService.spiApi.AckFlowEndedAndBackToIdle();

      this.activeModal.dismiss(this.signatureDeclined || this.failedReason === 'INCORRECT PIN' ? this.receipt : false);

    }
    else {
      this.complete         = true;
      this.receipt.complete = true;

      if (!this.receipt.approval_type) {


        this.receipt.approval_type = 'pin';


      }

      this.assemblyPaymentsService.spiApi.AckFlowEndedAndBackToIdle();

      this.activeModal.close(this.receipt);
    }
  }

  declineSignature () : void {


    this.assemblyPaymentsService.spiApi.AcceptSignature(false);

    this.signatureRequired     = false;
    this.signatureDeclined     = true;
    this.receipt.approval_type = 'signature';


  }

  overrideAsPaid () : void {
    this.transactionUnknown = false;
    this.success            = true;
    this.message            = this.isRefund ? 'Refund Successful' : 'Purchase Successful';

    if (this.data) {


      this.customer_receipt = this.data.customer_receipt;


    }

    this.changeDetectorRef.detectChanges();
  }

  print ( id : string ) : Promise<string> {
    if (!this.signatureAcquired) {

      window.open(`${ API.url }/reports/jasper_eftpos_receipt/merchant_with_sig/${ id }.pdf`, '_blank');

      return Promise.resolve(id);

    }
  }

  retryPayment () : void {


    this.assemblyPaymentsService.spiApi.AckFlowEndedAndBackToIdle();

    this.message            = '';
    this.success            = false;
    this.failed             = false;
    this.signatureRequired  = false;
    this.signatureDeclined  = false;
    this.transactionUnknown = false;
    this.complete           = false;
    this.canCancel          = false;

    this.run();


  }

  run () : void {
    if (this.assemblyPaymentsService.isTerminalPaired()) {
      const id = `${ Date.now() }-${ this.payment.id }`;

      this.assemblyPaymentsService.spiApi.AckFlowEndedAndBackToIdle();

      if (this.payment.moto) {


        this.assemblyPaymentsService.spiApi.InitiateMotoPurchaseTx(id, this.amount);


      }
      else if (this.isRefund) {
        this.assemblyPaymentsService.spiApi.InitiateRefundTx(id, this.amount);
      }
      else {
        this.assemblyPaymentsService.spiApi.InitiatePurchaseTxV2(id, this.amount, 0, 0, false, this.assemblyPaymentsService.receiptOptions, 0);
      }
    }
  }

  private _onTxFlowStateChanged ( e : any ) : void {
    if (e.detail.RequestSent && e.detail.Success === 'Unknown') {

      this.canCancel = true;

    }

    if (e.detail.Success === 'Success') {


      this.success                  = true;
      this.message                  = this.isRefund ? 'Refund Successful' : 'Purchase Successful';
      this.data                     = e.detail.Response.Data;
      this.receipt.customer_receipt = this.data.customer_receipt;
      this.receipt.merchant_receipt = this.data.merchant_receipt;
      this.receipt.payment_status   = 'success';

      this.changeDetectorRef.detectChanges();


    }

    else if (e.detail.Success === 'Failed') {
      let errorMessage;

      this.failed = true;

      if (e.detail.Response) {
        const response = e.detail.Response;

        if (response.Data) {
          if (response.Data.error_reason) {
            const errorReason = response.Data.error_reason;

            if (errorReason === 'OPERATION_IN_PROGRESS') {


              errorMessage = response.Data.error_detail;


            }

            else if (errorReason === 'TXN_PAST_POINT_OF_NO_RETURN') {
              this.canCancel = false;
            }

            else {
              if (this.canceled && this.canCancel) {

                this.assemblyPaymentsService.spiApi.CancelTransaction();

                this.assemblyPaymentsService.spiApi.AckFlowEndedAndBackToIdle();

              }
            }
          }
        }
      }

      const purchaseResponse = new PurchaseResponse(e.detail.Response);

      this.failedReason = purchaseResponse.GetResponseText();

      if (this.signatureDeclined || this.failedReason === 'INCORRECT PIN') {
        this.data                     = e.detail.Response.Data;
        this.receipt.customer_receipt = this.data.customer_receipt;
        this.receipt.merchant_receipt = this.data.merchant_receipt;

        if (this.signatureDeclined) {


          this.receipt.payment_status = 'declined_signature';


        }
        else {
          this.receipt.payment_status = 'incorrect_pin';
        }
      }

      this.message = `Terminal Busy: ${ errorMessage || purchaseResponse.GetResponseText() }`;

      this.changeDetectorRef.detectChanges();
    }

    else if (e.detail.Success === 'Unknown' && e.detail.AwaitingSignatureCheck) {
      this.data = e.detail;

      if (!this.current_receipt) {
        this.apiService.post('/eft_receipt', {
          invoice_id               : this.invoice.id || '',
          merchant_receipt_with_sig: this.data.SignatureRequiredMessage._receiptToSign,
          payment_status           : 'awaiting_signature',
          pos_terminal_id          : this.terminal.id
        }, 'eft_receipt')
        .then(( receipt ) => {
          this.current_receipt = receipt;

          if (!this.terminal.ap_print_receipt_from_pos) {


            return this.print(receipt.id);


          }
        })
        .then(() => {
          this.signatureRequired = true;
          this.message           = 'Please ask customer to sign receipt';

          this.changeDetectorRef.detectChanges();
        });
      }
      else {
        this.signatureRequired = true;
        this.message           = 'Please ask customer to sign receipt';

        this.changeDetectorRef.detectChanges();
      }
    }

    else if ((e.detail.Success === 'Unknown' || e.detail.Success === 'Failed') && e.detail.Finished) {
      this.transactionUnknown = true;
      this.message            = this.isRefund
        ? 'Check whether customer was actually refunded. \n\n What would you like to do next?'
        : 'Check whether customer actually paid. \n\n What would you like to do next?';

      this.changeDetectorRef.detectChanges();
    }

    else {
      this.message = e.detail.DisplayMessage;

      this.changeDetectorRef.detectChanges();
    }
  }
}
